export const COMPOSITE_FICO_STATUS = {
  ESTIMATED: 'ESTIMATED',
  FINAL: 'FINAL',
  CURRENT: 'CURRENT',
};
